
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/global-talent-trends-and-insights-2024",
      function () {
        return require("private-next-pages/global-talent-trends-and-insights-2024/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/global-talent-trends-and-insights-2024"])
      });
    }
  